import { PasskeyEnrollmentScreen } from '../passkey-enrollment'

export default function PasskeyEnrollmentLocalScreen() {
  return <PasskeyEnrollmentScreen variant="passkey-enrollment-local" />
}
